import PropTypes from 'prop-types';
import styles from './button-switch.module.scss';
import { augmentClassName } from '../../../utils/GlobalCssProxy';
import useProfileAppContext from '../../../stores/profile/use-profile-app-context';

const className = augmentClassName(styles);

const ButtonSwitch = ({ options, selected, onChange, showOnMobile }) => {
  selected = selected || options[0];
  return (
    <span {...className('d-print-none', 'button-group', 'font-family-sans-serif', showOnMobile ? '' : 'mobile-hide')}>
      {options.map(opt => {
        const isSelected = selected === opt;
        return (
          <button
            key={opt.label}
            {...className('color-black', isSelected ? 'active' : 'bg-white')}
            onClick={() => isSelected || onChange(opt)}
          >
            {opt.label}
          </button>
        );
      })}
    </span>
  );
};

ButtonSwitch.defaultProps = {
  onChange: () => {}, // eslint-disable-line no-empty-function
  options: [],
  showOnMobile: true
};

ButtonSwitch.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string
    })
  ),
  selected: PropTypes.shape({
    label: PropTypes.string
  }),
  showOnMobile: PropTypes.bool
};

export default ButtonSwitch;
